module.exports = __webpack_public_path__ + "img/device_icon_1.c45c789c.png";